// src/components/BottomNav.js
import React from 'react';

const BottomNav = ({ activeTab, setActiveTab }) => {
    return (
        <div className="bottom-nav">
            <button className={`nav-item ${activeTab === 'home' ? 'active' : ''}`} onClick={() => setActiveTab('home')}>
                <span className="nav-icon">📅</span><span>ホーム</span>
            </button>
            <button className={`nav-item ${activeTab === 'ranking' ? 'active' : ''}`} onClick={() => setActiveTab('ranking')}>
                <span className="nav-icon">🏆</span><span>ランク</span>
            </button>
            <button className={`nav-item ${activeTab === 'team' ? 'active' : ''}`} onClick={() => setActiveTab('team')}>
                <span className="nav-icon">👕</span><span>チーム</span>
            </button>
            <button className={`nav-item ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => setActiveTab('profile')}>
                <span className="nav-icon">👤</span><span>マイページ</span>
            </button>
            <button className={`nav-item ${activeTab === 'guide' ? 'active' : ''}`} onClick={() => setActiveTab('guide')}>
                <span className="nav-icon">📖</span><span>使い方</span>
            </button>
        </div>
    );
};

export default BottomNav;